import type { ClipLayout, ScriptContent } from "./constants"

export default function TimelineTrackText({
  clips,
  content,
  selectedIndex,
  onSelect,
}: {
  clips: ClipLayout[]
  content: ScriptContent | undefined
  selectedIndex: number
  onSelect: (index: number) => void
}) {
  const contentScenes = content?.scenes?.filter((s) => s.type !== "closing") || []

  return (
    <div className="relative flex h-8">
      {clips.map((clip) => {
        const isSelected = clip.type === "title"
          ? selectedIndex === -1
          : clip.type === "closing"
            ? selectedIndex === clip.index
            : selectedIndex === clip.index

        const text = clip.type === "title"
          ? (content?.headline || "Title")
          : clip.type === "closing"
            ? (content?.cta_text || "Closing")
            : (contentScenes[clip.index]?.text || "")

        const selectIndex = clip.type === "title" ? -1 : clip.index

        return (
          <button
            key={`text-${clip.index}-${clip.type}`}
            type="button"
            onClick={() => onSelect(selectIndex)}
            className={`absolute top-0.5 bottom-0.5 overflow-hidden rounded px-1.5 text-left transition-all ${
              isSelected
                ? "bg-red/8 ring-1 ring-red/30"
                : clip.type === "title"
                  ? "border border-dashed border-stone/30 bg-stone/5 hover:bg-stone/10"
                  : clip.type === "closing"
                    ? "bg-stone/8 hover:bg-stone/12"
                    : "bg-stone/5 hover:bg-stone/10"
            }`}
            style={{ left: clip.left, width: clip.width }}
          >
            <span className="line-clamp-1 text-[9px] leading-[28px] text-warm-grey">
              {text || "\u00A0"}
            </span>
          </button>
        )
      })}
    </div>
  )
}
